import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html, nothing } from 'lit';

export function buttonsTemplate(this: TefComs4csMicroFrontend) {
  if (this.mode === 'buttons' && !this.store.identity?.readonly) {
    return html`
      <one-cluster>
        <one-button
          .disabled=${!(this.store.touched && this.store.hasModifiedFromOriginal)}
          @click=${async () => { await this.store.save(); }}>
          Speichern
        </one-button>
      </one-cluster>`;
  }

  if (this.mode === 'buttons:undoAll' && this.store.touched && this.store.hasModifiedFromOriginal) {
    return html`
      <one-cluster x="end">
        <one-button
          @click=${() => { this.store.undoAll(); }}>
          Änderungen widerrufen
        </one-button>
      </one-cluster>`;
  }

  return html`${nothing}`;
}
